import { ThemeValuesEnum } from '../../../../enuns/AfterSales/themeValues.enum';
import translate from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import api from '../../../../scripts/api';
import { VehicleTypeEnum } from '../../../../scripts/core/vehicleType/constants';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class AfterSalesShapeFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const idSplit = this.options.id.split('-');
        const selected = parseInt(idSplit[idSplit.length - 1]) || 0;
        let showFilterPGTS = this.options.showFilterPGTS;
        const data = [];

        // PGTS
        if (selected === ThemeValuesEnum.MotorcyclePartsAndWorkshop
            || selected === ThemeValuesEnum.PGTS
            || showFilterPGTS) {
            const isVehicleTypeMotorcycle = environment.get('CONFIG.USERVEHICLETYPE') === VehicleTypeEnum.Moto;
            const dataSourcePgts = _.map(environment.get('CONFIG.FILTERS.MAPTHEME_PGTS'), t => {
                if (isVehicleTypeMotorcycle && t.nome.toLocaleLowerCase().indexOf('oficina') > -1) {
                    return ({ text: translate('Common.Services'), value: t.id });
                };

                return ({ text: t.nome, value: t.id });
            });
            const dataSourceCompanySize = _.map(environment.get('CONFIG.FILTERS.TRAFFIC_GENERATOR_POLE_COMPANY_SIZES'), t => ({ text: t.nome, value: t.id }));

            data.push({
                name: 'pgtsType',
                position: 1,
                data: dataSourcePgts,
                fields: [
                    {
                        title: isVehicleTypeMotorcycle ? translate('Common.Type') : translate('Common.TrafficGeneratorPoleType'),
                        name: 'pgtsType',
                        value: 'value',
                        text: 'text',
                        type: 'multiselect',
                    }
                ]
            }, {
                name: 'companySize',
                position: 2,
                data: dataSourceCompanySize,
                fields: [
                    {
                        title: translate('Common.Port'),
                        name: 'companySize',
                        value: 'value',
                        text: 'text',
                        type: 'multiselect',
                    }
                ]
            });
        }

        // FROTA REPARAVEL e PARQUE CIRCULANTE
        if (selected === ThemeValuesEnum.RepairableFleetArea || selected === ThemeValuesEnum.VehicleFleetArea) {
            const sourceSegments = environment.get('CONFIG.FILTERS.SEGMENTS_CLIENT');
            const sourceFuelTypes = environment.get('CONFIG.FILTERS.FUEL_TYPES');
            const sourceTypeEngine = environment.get('CONFIG.FILTERS.ENGINE_TYPE');

            data.push(...[
                {
                    name: 'vehicletype_segments',
                    position: 1,
                    data: sourceSegments,
                    fields: [
                        {
                            title: translate('Common.AfterSalesVehicleType'),
                            name: 'vehicleTypes',
                            value: 'vehicleTypeId',
                            text: 'vehicleTypeName',
                            type: 'dropdown'
                        },
                        {
                            title: translate('Common.Segment'),
                            name: 'segments',
                            value: 'segmentId',
                            text: 'segmentName',
                            type: 'multiselect',
                        },
                        {
                            title: translate('Common.Brand'),
                            name: 'brands',
                            value: 'brandId',
                            text: 'brandName',
                            type: 'multiselect',
                        },
                        {
                            title: translate('Common.Family'),
                            name: 'families',
                            value: 'familyId',
                            text: 'familyName',
                            type: 'multiselect',
                        }

                    ]
                },
            ]);

            if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_TERRITORIAL_BOUNDARIES.filterFuelType)) {
                data.push({
                    name: 'fueltypes',
                    position: 2,
                    data: sourceFuelTypes,
                    fields: [
                        {
                            title: translate('Common.AfterSalesFuelType'),
                            name: 'fuelTypes',
                            value: 'id',
                            text: 'nome',
                            type: 'multiselect',
                        }
                    ]
                });
            }

            if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_TERRITORIAL_BOUNDARIES.filterEngineType)) {
                const engineType = [
                    {
                        name: 'engineType',
                        position: 4,
                        data: sourceTypeEngine,
                        fields: [
                            {
                                title: translate('Common.EngineType'),
                                name: 'engineType',
                                value: 'id',
                                text: 'nome',
                                type: 'multiselect',
                                orderBy: 'nome'
                            }
                        ]
                    }
                ];

                data.push(...engineType);
            }
        }

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/afterSalesShape.factory.js